<template>
  <v-app>
    <router-view />
    <site-footer></site-footer>
  </v-app>
</template>

<script>
import SiteFooter from "../src/components/Footer.vue";

export default {
  name: "App",

  components: {
    "site-footer": SiteFooter,
  },
};
</script>
